import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';
import { SPCandidateHistorySchedulingNcarbExamAuthFormLocType } from '../ncarb-exam-auth-form/ncarb-exam-auth-form.locs';

export const ncarbSchedulingPathStart = 'Candidate|Scheduling|Scheduling|';
export const ncarbSchedulingSharedProperties: Pick<
	LocDef,
	'shared' | 'htmlAllowed' | 'feature' | 'portal'
> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.ExamSchedulingNcarbAuthorizationDetail,
	portal: 'SP',
};

export type SPCandidateHistorySchedulingNcarbExamAuthEditLocNames =
	| 'SPCandidateHistorySchedulingNcarbExamAuthEditTitle'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEditButton'
	| 'SPCandidateHistorySchedulingNcarbExamAuthEditCancelButton';

export const spCandidateHistorySchedulingNcarbExamAuthEditLocs: LocDefs<SPCandidateHistorySchedulingNcarbExamAuthEditLocNames> =
	{
		SPCandidateHistorySchedulingNcarbExamAuthEditTitle: {
			defaultValue: 'Edit Authorization',
			description: 'Dialog title for the edit authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Edit Authorization|Dialog Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEditButton: {
			defaultValue: 'Save Changes',
			description: 'Button to save the authorization.',
			displayPath: `${ncarbSchedulingPathStart}Edit Authorization|Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbExamAuthEditCancelButton: {
			defaultValue: 'Cancel',
			description: 'Button to cancel the edit authorization dialog.',
			displayPath: `${ncarbSchedulingPathStart}Edit Authorization|Cancel Button`,
			displayType: 'Button',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbExamAuthEditLocType =
	LocMap<SPCandidateHistorySchedulingNcarbExamAuthEditLocNames> &
		SPCandidateHistorySchedulingNcarbExamAuthFormLocType;
